import React from 'react';
import { Container,Image } from '@chakra-ui/react';
import "../css/Coding.css";
import leetcode from "../images/leetcode.svg";
import geeksforgeeks from "../images/geeksforgeeks.svg"

function Coding(){
    return(
        <>
        <Container>
            <br/>
            <div className="heading">
                <h4>Coding Profile</h4>
            </div>
            <br/>
            <div class="code-profile">
            <figure>
                <a href="https://leetcode.com/DevKD/"><Image src={leetcode} width="32" height="32" m="15px"/></a>
                <figcaption>Leetcode</figcaption>
            </figure>
            <figure>
                <a href="https://auth.geeksforgeeks.org/user/devanshukd27/"><Image src={geeksforgeeks} width="32" height="32" m="15px"/></a>
                <figcaption>Geek For Geeks</figcaption>
            </figure>
            </div>
        </Container>
        </>
    );
}

export default Coding;